'use strict';

function PortalNav() {
  this.extends = [];
  this.node = null;
  this.$node = null;
  this.id = null;

  this._classes = {
    active: 'active',
    referralPanel: 'js--ui-generic-layout',
    helpLink: 'js--memberNav__help-link'
  };

  this.maxWaitTime = 2000;

  this.init = function () {
    this.$node = $(this.node);
    this._portalPresenter = document.getElementById('Portal').mogo();

    this._setupEnvironmentLinks();

    $(window).on('popstate', this._setActiveNavElements.bind(this));
    $(window).on('pushstate', this._setActiveNavElements.bind(this));

    this._setActiveNavElements();
    this._portalPresenter.scanNodeForClickAnalytics(this.node); // scan DAI for dynamically created elements

    // Bitcoin Sunset
    // setTimeout to wait for DataLayer to be populated with campaign
    // setTimeout(() => {
    //   this._createAnchorTile(); // A/B Test
    // }, this.maxWaitTime);
  };

  this.initAllReady = function () {};

  /*
    initLiveChat: attaches event handler and then displays the help and support menu item.
    This method is called from the Portal Presenter class when the account model is loaded.
    Account model data is needed to auto populate live chat fields.
  */
  this.initHelpAndSupport = function () {
    var _this = this;

    this._helpLink = this.node.getElementsByClassName(this._classes.helpLink)[0];
    this._liveChatComponent = document.querySelectorAll("[data-mogo-UI='LiveChat']")[0];
    var liveChatNotInitilized = this._helpLink && !this._liveChatComponent;
    /* 
      Bind event only executed when window.LC_API object is loaded and ready to use 
      (ie live chat is initilized and ready),
    */
    var setupBindEvent = function setupBindEvent(liveChatAPI) {
      _this._helpLink.addEventListener('click', function (e) {
        e.preventDefault();
        if (liveChatAPI && liveChatAPI.open_chat_window) {
          window.LC_API.open_chat_window();
        } else {
          console.warn('Error initilizing LiveChat UI Component');
        }
      });
    };

    /* 
      LiveChat component exists in other places throughout app, 
      so can potentially already be initilized elsewhere.
      In this case, just setup bind event - don't need to re-initilize
    */
    if (liveChatNotInitilized) {
      this._helpLink.mogo().create('LiveChat', {
        presenter: mogo.registry.mogoUI.repo.Portal.presenter,
        afterLoad: function () {
          var hasExpandedParam = getURLParameter('chat') && getURLParameter('chat').trim() === 'expanded';
          // Hide chat bubble if doesn't have expanded URL parm and user is not engaged
          if (!hasExpandedParam) {
            this._helpLink.mogo().hideChatIfNotEngaged();
          }
          // Fire bind event for Help Link
          setupBindEvent(window.LC_API || {});
        }.bind(this)
      });
    } else if (this._liveChatComponent.length && this._liveChatComponent.mogo().declaredClass) {
      var liveChatReady = this._liveChatComponent.mogo().afterLoadPromise;

      $.when(liveChatReady).then(function () {
        _this._liveChatComponent.mogo().hideChatIfNotEngaged();
        _this._helpLink = _this._liveChatComponent;
        setupBindEvent(window.LC_API || {});
      });
    }
  };

  /*
    Programatically create side anchor tiles with field configs
    for A/B test. (the colorful background anchor at the bottom of the nav).
     Generic Layout has code to determine whether the users are in control or variant-1 bucket.
  */
  // this._createAnchorTile = function () {
  //   this._$referralPanel = this.node.getElementsByClassName(this._classes.referralPanel)[0];

  //   this.genericLayoutConfig = {
  //     contentId: '5lefjvLqJzMEVLwFofJRjL',
  //     contentSpace: 'App',
  //     contentType: 'genericLayout',
  //     preserveAspectRatio: 'true',
  //     fieldConfigs: {
  //       media1: { callback: () => this.displayAnchorTile() }
  //     }
  //   };

  //   this._$referralPanel.mogo().create('GenericLayout', this.genericLayoutConfig);
  // };

  // this.displayAnchorTile = function () {
  //   const tileBody = this._$referralPanel.getElementsByClassName('js--tile-body')[0];
  //   tileBody.classList.remove('hide');
  // };

  this._setActiveNavElements = function () {
    var currentUrlPath = window.location.pathname;
    var listItems = this.$node.find('ul li');
    for (var i = 0; i < listItems.length; i++) {
      var anchorElements = $(listItems[i]).find('a');
      var activeHref = false;
      for (var j = 0; j < anchorElements.length; j++) {
        var anchor = anchorElements[j];
        if (anchor.host && anchor.host !== window.location.host) {
          continue;
        }

        var anchorUrl = $(anchor).prop('href');
        if (anchorUrl !== '') {
          anchorUrl = '/' + anchorUrl.split('/').slice(3, 6).join('/');
          if (currentUrlPath.indexOf(anchorUrl) > -1) {
            activeHref = true;
            break;
          }
        }
      }

      if (activeHref) {
        $(listItems[i]).addClass(this._classes.active);
      } else {
        $(listItems[i]).removeClass(this._classes.active);
      }
    }
  };

  this._setupEnvironmentLinks = function () {
    EnvironmentLinks.applyEnvironmentLinks(this.$node);
  };
}